import { useEffect } from 'react';
import { useGlobalStoreSelector } from './stores/global.store';

// The platform favicon, used before any Brand resolves and for unbranded workspaces. Not a
// tenant asset: no shell site hardcodes a foreign CloudFront logo anymore.
const PLATFORM_FAVICON = '/vadio_192.svg';

export const Favicon = () => {
	// A route-tree override (the customer portal) wins over the resolved-brand slot: a branded
	// workspace paints its own favicon, everything else paints the platform mark.
	const faviconUrl = useGlobalStoreSelector(
		(state) =>
			state.faviconOverride ??
			(state.resolvedBrand?.isBranded ? (state.resolvedBrand.faviconUrl ?? PLATFORM_FAVICON) : PLATFORM_FAVICON),
	);

	useEffect(() => {
		// Reuses the index.html link because browsers prefer a sized icon over one added beside it.
		const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
		if (!link) return;
		link.removeAttribute('sizes');
		link.removeAttribute('type');
		link.href = faviconUrl;
	}, [faviconUrl]);

	return null;
};
